
import { AnimationFileLoader } from '../../../utilis/animation-loader'; // Adjust the path
import {NavLink } from "react-router-dom";

//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />

function Ranking() {
    AnimationFileLoader();

  return (
    <>
   
      {/* Author */}
    <div className="author-area">
        <div className="author-cover" data-bg-img="/img/bg/author-cover.png"></div>
    </div>
    {/* End Author */}

    {/* Ranking */}
    <section className="pt-120 pb-120">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-7">
                    {/* Section Title */}
                    <div className="section-title text-white text-center mb-35">
                        <h2>Top NFTs</h2>
                        <p>The top NFTs on Anefty, ranked by volume, floor price and other statistics. "Multiple" if you
                            want to sell by ones collectibles upload your work likes image, video, audio times for
                            Anefty.</p>
                    </div>
                    {/* End Section Title */}
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="d-flex flex-wrap justify-content-center mb-50">
                        <select className="select-rounded lg mb-10 mr-20">
                            <option value="7_days">Last 7 Day</option>
                            <option value="24_hours">24 Hours</option>
                            <option value="30_days">Last 30 Day</option>
                        </select>
                        <select className="select-rounded lg mb-10 mr-20">
                            <option value="categorys">all category</option>
                            <option value="digital_art">Digital Art</option>
                            <option value="memes">Memes</option>
                            <option value="virtual_fashion">Virtual Fashion</option>
                            <option value="domain_names">Domain Names</option>
                        </select>
                        <select className="select-rounded mb-10 lg">
                            <option value="offers">All Chains</option>
                            <option value="ethereum">Ethereum</option>
                            <option value="polygon">Polygon</option>
                            <option value="klaytn">Klaytn</option>
                        </select>
                    </div>
                </div>
            </div>

            <div className="row mt-n3">
                <div className="col-12 pb-lg-3">
                    <div className="table-responsive">
                        <table className="text-nowrap">
                            <thead>
                                <tr>
                                    <th>Collection</th>
                                    <th>Volume</th>
                                    <th>24h %</th>
                                    <th>7d %</th>
                                    <th>Floor Price</th>
                                    <th>Owners</th>
                                    <th>Assets</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td>
                                        <NavLink to="pages/product-details" className="product-wrapper">
                                            <span className="ribbon" data-count="1"></span>
                                            <img src="/img/media/tnft1.png" className="svg"/>
                                            <span>AneftyPunks</span>
                                        </NavLink>
                                    </td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>9,635.63</span>
                                        </div>
                                    </td>
                                    <td><span className="text-danger">-1.12%</span></td>
                                    <td><span className="text-success">+38.13%</span></td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>34-96</span>
                                        </div>
                                    </td>
                                    <td><span>3.2K</span></td>
                                    <td><span>10.0K</span></td>
                                </tr>
                                <tr>
                                    <td>
                                        <NavLink to="pages/product-details" className="product-wrapper">
                                            <span className="ribbon" data-count="2"></span>
                                            <img src="/img/media/tnft2.png" className="svg"/>
                                            <span>KingzAnefty</span>
                                        </NavLink>
                                    </td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>2,818.2</span>
                                        </div>
                                    </td>
                                    <td><span className="text-danger">-2.12%</span></td>
                                    <td><span className="text-danger">-44.13%</span></td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>4.03</span>
                                        </div>
                                    </td>
                                    <td><span>5.1K</span></td>
                                    <td><span>22.9K</span></td>
                                </tr>
                                <tr>
                                    <td>
                                        <NavLink to="pages/product-details" className="product-wrapper">
                                            <span className="ribbon" data-count="3"></span>
                                            <img src="/img/media/tnft3.png" className="svg"/>
                                            <span>NTFsBaAz</span>
                                        </NavLink>
                                    </td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>3,154.35</span>
                                        </div>
                                    </td>
                                    <td><span className="text-success">+35.38%</span></td>
                                    <td><span className="text-danger">03.46%</span></td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>99.05</span>
                                        </div>
                                    </td>
                                    <td><span>1.8K</span></td>
                                    <td><span>11.1K</span></td>
                                </tr>
                                <tr>
                                    <td>
                                        <NavLink to="product-details" className="product-wrapper">
                                            <span className="ribbon" data-count="4"></span>
                                            <img src="/img/media/tnft4.png" className="svg"/>
                                            <span>CyberKongz</span>
                                        </NavLink>
                                    </td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>2,396.97</span>
                                        </div>
                                    </td>
                                    <td><span className="text-success">+80.08%</span></td>
                                    <td><span className="text-success">+108.83%</span></td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>7.27</span>
                                        </div>
                                    </td>
                                    <td><span>1.6K</span></td>
                                    <td><span>4.1K</span></td>
                                </tr>
                                <tr>
                                    <td>
                                        <NavLink to="product-details.html" className="product-wrapper">
                                            <span className="ribbon" data-count="5"></span>
                                            <img src="/img/media/tnft5.png" className="svg"/>
                                            <span>CatsAnefty</span>
                                        </NavLink>
                                    </td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>1,218.35</span>
                                        </div>
                                    </td>
                                    <td><span className="text-success">+20.28%</span></td>
                                    <td><span className="text-danger">-62.21%</span></td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>1.38</span>
                                        </div>
                                    </td>
                                    <td><span>618K</span></td>
                                    <td><span>10.1K</span></td>
                                </tr>
                                <tr>
                                    <td>
                                        <NavLink to="product-details.html" className="product-wrapper">
                                            <span className="ribbon" data-count="6"></span>
                                            <img src="/img/media/tnft6.png" className="svg"/>
                                            <span>DegenerArts</span>
                                        </NavLink>
                                    </td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>1,011.31</span>
                                        </div>
                                    </td>
                                    <td><span className="text-danger">-29.62%</span></td>
                                    <td><span className="text-danger">-35.00%</span></td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>0.89</span>
                                        </div>
                                    </td>
                                    <td><span>4.1K</span></td>
                                    <td><span>10.0K</span></td>
                                </tr>
                                <tr>
                                    <td>
                                        <NavLink to="product-details.html" className="product-wrapper">
                                            <span className="ribbon" data-count="7"></span>
                                            <img src="/img/media/tnft7.png" className="svg"/>
                                            <span>Crystals</span>
                                        </NavLink>
                                    </td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>962.21</span>
                                        </div>
                                    </td>
                                    <td><span className="text-danger">-31.21%</span></td>
                                    <td><span className="text-success">+2.93%</span></td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>0.15</span>
                                        </div>
                                    </td>
                                    <td><span>3.8K</span></td>
                                    <td><span>10.3K</span></td>
                                </tr>
                                <tr>
                                    <td>
                                        <NavLink to="product-details.html" className="product-wrapper">
                                            <span className="ribbon" data-count="8"></span>
                                            <img src="/img/media/tnft8.png" className="svg"/>
                                            <span>SuperNFTs</span>
                                        </NavLink>
                                    </td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>874.58</span>
                                        </div>
                                    </td>
                                    <td><span className="text-danger">-67.11%</span></td>
                                    <td><span className="text-success">+121.33%</span></td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>0.25</span>
                                        </div>
                                    </td>
                                    <td><span>5.3K</span></td>
                                    <td><span>27.5K</span></td>
                                </tr>
                                <tr>
                                    <td>
                                        <NavLink to="product-details.html" className="product-wrapper">
                                            <span className="ribbon" data-count="9"></span>
                                            <img src="/img/media/tnft9.png" className="svg"/>
                                            <span>LazyLions</span>
                                        </NavLink>
                                    </td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>453.8</span>
                                        </div>
                                    </td>
                                    <td><span className="text-success">+76.00%</span></td>
                                    <td><span className="text-success">+121.33%</span></td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>0.07</span>
                                        </div>
                                    </td>
                                    <td><span>2.1K</span></td>
                                    <td><span>8.0K</span></td>
                                </tr>
                                <tr>
                                    <td>
                                        <NavLink to="pages/product-details" className="product-wrapper">
                                            <span className="ribbon" data-count="10"></span>
                                            <img src="/img/media/tnft10.png" className="svg"/>
                                            <span>SupDucks</span>
                                        </NavLink>
                                    </td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>491.72</span>
                                        </div>
                                    </td>
                                    <td><span className="text-danger">-44.27%</span></td>
                                    <td><span className="text-danger">-21.90%</span></td>
                                    <td>
                                        <div>
                                            <img src="/img/icons/eth.svg" alt="" className="svg"/>
                                            <span>0.94</span>
                                        </div>
                                    </td>
                                    <td><span>3.4K</span></td>
                                    <td><span>10.0K</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="col-lg-12 d-flex justify-content-center mt-30">
                    <NavLink to="#" className="btn"><img src="/img/icons/btn-loadmore.svg" alt="" className="svg"/>
                        Load
                        More</NavLink>
                </div>
            </div>
        </div>
    </section>
    {/* End Ranking */}
  
    </>
  );
}

export default Ranking;
